export default "__VITE_ASSET__b4c90276__"